import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocationServiceService {

  norrisLocs = [[53.437194, -2.918194], [53.438250, -2.918556], [53.439083, -2.918694], [53.438444, -2.920556], [53.439111, -2.921083], [53.439417, -2.922056]];

  constructor() {
  }


  getNextLocation(location, section): google.maps.LatLngLiteral {
    switch (location) {
      case 0 :
        return this.getLocationForWarrington(section);
      case 1 :
        return this.getLocationForWarrington(section);
      case 2 :
        return this.getLocationForWarrington(section);
      case 3 :
        return this.getLocationForWarrington(section);
      case 4 :
        return this.getLocationForWarrington(section);
      case 5 :
        return this.getLocationForWarrington(section);

    }

    return {lat: 1, lng: 1};
  }

  getLocationForStanleyParkSection(section): google.maps.LatLngLiteral {
    switch (section) {
      case 0:
        return {lat: 53.433091, lng: -2.967442};
      case 1:
        return {lat: 53.4332882, lng: -2.9680292};
      case 2:
        return {lat: 53.4339006, lng: -2.9681325};
      case 3:
        return {lat: 53.4366915, lng: -2.9663730};
      case 4:
        return {lat: 53.4363589, lng: -2.9648649}; // {lat: 53.436326, lng:  -2.964938};
      case 5:
        return {lat: 53.4344099, lng: -2.9648454}; // {lat: 53.434412, lng: -2.964259};
      case 6:
        return {lat: 53.4339961, lng: -2.9655170}; // {lat: 53.433914, lng: -2.965730};
      default :
        return {lat: 53.433091, lng: -2.967442};
    }

    /**
     * (53.4339006, -2.9681325) pumpkin 3

     (53.4366915, -2.9663730) feather 4

     (53.4363589, -2.9648649) Sweet 5

     (53.4344099, -2.9648454) Mirror 6

     (53.4339961, -2.9655170) book 7
     */

  }

  getLocationForWarrington(section) {
    switch (section) {
      case 0:
        return {lat: 53.388290, lng: -2.591381};
      case 1:
        return {lat: 53.3881842, lng: -2.5930339};
      case 2:
        return {lat: 53.3892011, lng: -2.5935298};
      case 3:
        return {lat: 53.3897038, lng: -2.5934648};
      case 4:
        return {lat: 53.3887858, lng: -2.5996553}; // {lat: 53.436326, lng:  -2.964938};
      case 5:
        return {lat: 53.3876135, lng: -2.5982220}; // {lat: 53.434412, lng: -2.964259};
      case 6:
        return {lat: 53.3878646, lng: -2.5969171}; // {lat: 53.433914, lng: -2.965730};
      default :
        return {lat: 53.388290, lng: -2.591381};
    }


    // 0 - this is the start poster, don’t think you need it?(53.3883131, -2.5909328)
    //   1 - Step Mother video(53.3881842, -2.5930339)
    // 2 - bird video (53.3892011, -2.5935298)
    // 3 - Hansel & Gretel video (53.3897038, -2.5934648)
    // 4 - Rat video (53.3887858, -2.5996553)
    // 5 - Rumplestiltskin video (53.3876135, -2.5982220)
    // 6 - Final Fairy God Mother video (53.3878646, -2.5969171)


  }


  getLocationForNorrisGreenSection(section): google.maps.LatLngLiteral {
    return {lat: this.norrisLocs[section - 1][0], lng: this.norrisLocs[section - 1][1]};
    // switch (section) {
    //   case 1:
    //     return {lat: this.norrisLocs[section - 1][0], lng: this.norrisLocs[section - 1][1]}; // apple
    //   case 2:
    //     return {lat: 53.438056, lng: 7.048611}; // pumpkin
    //   case 3:
    //     return {lat: 53.438889, lng: 7.048611}; // feather
    //   case 4:
    //     return {lat: 1, lng: 1};
    //   case 5:
    //     return {lat: 1, lng: 1};
    //   case 6:
    //     return {lat: 1, lng: 1};
    //   case 7:
    //     return {lat: 1, lng: 1};
    //
    // }
    //
    // return {lat: 1, lng: 1};
  }

}
